var Base = require('./_BaseView'),
    scope = require('scope'),
    View =  Base.extend({
        template: require('templates/pages/error.hbs'),
        name: 'error',
        behaviors: {
        },
        ui: {
        },
        events: {
        },
        onAttach: function(){
            scope.metrics.pageview('erro');
        }
    });
module.exports = View;



// WEBPACK FOOTER //
// ./resources/scripts/views/Error.js